import { render } from "./AddEmployeesModal.vue?vue&type=template&id=55980834&lang=pug"
import script from "./AddEmployeesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEmployeesModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__